<template>

    <hr-teams-index></hr-teams-index>

</template>

<script>

    import HrTeamsIndex from "../../../components/HR/Teams/Index";

    export default {

        components: {
            HrTeamsIndex,
        },

        metaInfo: {
            title:'Teams',
        },

        name:'HrTeamsView',

    }

</script>
